import createReactComponent from '../createReactComponent';
var Wind = createReactComponent('Wind', [['path', {
  d: 'M17.7 7.7a2.5 2.5 0 111.8 4.3H2',
  key: '2ht40z'
}], ['path', {
  d: 'M9.6 4.6A2 2 0 1111 8H2',
  key: '1a2hs9'
}], ['path', {
  d: 'M12.6 19.4A2 2 0 1014 16H2',
  key: 'iodfau'
}]]);
export default Wind;